var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqLineBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 415,
    viewBox: "0 0 216 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 97.0244,
    y1: 414.32,
    x2: 97.0244,
    y2: -118.315,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 121.813,
    x2: 216,
    y2: 121.813,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 276.063,
    x2: 216,
    y2: 276.063,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8994,
    y1: 414.32,
    x2: 19.8994,
    y2: -118.315,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 135.583,
    y1: 414.32,
    x2: 135.583,
    y2: -118.315,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 6.13378,
    x2: 216,
    y2: 6.1338,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 160.376,
    x2: 216,
    y2: 160.376,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 314.626,
    x2: 216,
    y2: 314.626,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 58.458,
    y1: 414.32,
    x2: 58.458,
    y2: -118.315,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 83.251,
    x2: 216,
    y2: 83.251,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 237.501,
    x2: 216,
    y2: 237.501,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 174.145,
    y1: 414.32,
    x2: 174.145,
    y2: -118.315,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 44.6885,
    x2: 216,
    y2: 44.6885,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 198.938,
    x2: 216,
    y2: 198.938,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: -213,
    y1: 353.188,
    x2: 216,
    y2: 353.188,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.76369
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLineBg);
export default __webpack_public_path__ + "static/media/FAQLineBG.8b7dbf0cac3caf3e2ec5046175c35dea.svg";
export { ForwardRef as ReactComponent };